import { Component, OnInit, inject } from '@angular/core';
import { PortalService } from '../portal.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PortalHomepageSections, PortalMetrics } from '../../shared/configurations/portal-homepage.constant';
import { forkJoin, Observable, filter, map, startWith } from 'rxjs';
import { DeferLoadModule } from '@trademe/ng-defer-load';
import { PortalMetricsComponent } from '../portal-metrics/portal-metrics.component';
import { AsyncPipe } from '@angular/common';
import { AdditionsDatatableComponent } from './additions-datatable/additions-datatable.component';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';

@Component({
    selector: 'esp-portal-additions',
    templateUrl: './portal-additions.component.html',
    styleUrls: ['./portal-additions.component.scss'],
    imports: [CenteredBlockLayoutComponent, AdditionsDatatableComponent, PortalMetricsComponent, DeferLoadModule, AsyncPipe, TranslateModule]
})
export class PortalAdditionsComponent implements OnInit {
  private portalService = inject(PortalService);
  private translate = inject(TranslateService);


  showMetricsAdditions = false;
  worksByYear = [];
  total: Observable<any>;

  ngOnInit() {
    this.initTotalData();
    this.initChartData();
  }

  initTotalData() {
    this.getTotalAssetsCount();
  }

  initChartData() {
    const worksAddedByYearsMap = this.portalService.getHomepageSectionByCode(PortalHomepageSections.WORKS_ADDED).worksAddedByYearsMap;
    if (worksAddedByYearsMap) {
      const years = Object.keys(worksAddedByYearsMap);
      years.sort((a, b) => parseInt(a) - parseInt(b));
      const topYears = years.slice(Math.max(years.length - PortalMetrics.NUM_OF_ENTRIES_IN_WORKS_BY_YEARS_SECTION, 0));
      for (const year of topYears) {
        this.worksByYear.push({ name: year.toString(), value: worksAddedByYearsMap[year] });
      }
    }
  }

  getTotalAssetsCount() {
    this.total = forkJoin({
      name: this.translate.get('research.portal.works.added.total'),
      value: this.portalService.getTotalAssetsCount()
    })
      .pipe(
        filter(data => data?.value != null),
        startWith([{ name: '', value: 0 }]),
        map(data => [data])
      )

  }
}
